import { getLocaleFormat } from '@models/timeformats.js';

/**
 * Format a date to local date format
 * @param {String} start start time of interval
 * @param {String} end end time of interval
 * @param {String} locale locale for time format
 * @return {String} datetime range in given locale.
 */
export function formatDate(start, end, userLocale) {
    return `${getLocaleFormat(start, userLocale)} - ${getLocaleFormat(
        end,
        userLocale
    )}`;
}
